<template>
  <div v-if="children" class="block docx-heading4-block" :class="[`block-${children.blockId}`, children.blockStyles && children.blockStyles.textBackground ? 'background':'']">
    <div class="heading-content" :class="pageStyle">
      <v-spantext :elements="elements"  :children="children"></v-spantext>
    </div>
    <div >
      <slot></slot>
    </div>
    <v-highlight :blockId="children.blockId"></v-highlight>
    <v-blockbackground v-if="children.blockStyles && children.blockStyles.textBackground" :backgroundColor="children.blockStyles.textBackground"></v-blockbackground>
  </div>
</template>
<script>
import { pageStyles, getEleStyle } from "../utils/style";
import { isUrlRegExp, openUrl } from "../utils/utils";

export default {
  name: "h4-block",
  props: {
    children: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      getEleStyle,
      isUrlRegExp,
      openUrl,
    };
  },
  computed: {
    elements() {
      return this.children.blockAttr.heading4.elements || [];
    },
    pageStyle() {
      let dataStyle = this.children.blockAttr.heading4.style;
      let className = "";
      for (let key in dataStyle) {
        if (pageStyles[key]) {
          let value = dataStyle[key];
          className += pageStyles[key][value] + "";
        }
      }
      return className;
    },
  },
  methods: {},
};
</script>
<style >
.page-block-children .block.docx-heading4-block {
  margin-top: 18px;
  margin-bottom: 8px;
  font-size: 18px;
}
</style>